import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../../Axios";
import { DetailedReport } from "../../components/DetailedReport/DetailedReport";
import { ReportAppendixA } from "../../components/ReportAppendixA/ReportAppendixA";
import { ReportAppendixB } from "../../components/ReportAppendixB/ReportAppendixB";
import { ReportAppendixC } from "../../components/ReportAppendixC/ReportAppendixC";
import { ReportBarChart } from "../../components/ReportBarChart/ReportBarChart";
import { ReportExecutiveSummary } from "../../components/reportExecutiveSummary/ReportExecutiveSummary";
import "./Report.css";
import useAuth from "../../contexts/UserContext.tsx";
import { toast } from "sonner";
// import { KeyHighlightsReport } from '../../components/keyHighlightsReport/KeyHighlightsReport';

export const Report = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();

  const months = [
    {
      id: 1,
      name: "January",
    },
    {
      id: 2,
      name: "February",
    },
    {
      id: 3,
      name: "March",
    },
    {
      id: 4,
      name: "April",
    },
    {
      id: 5,
      name: "May",
    },
    {
      id: 6,
      name: "June",
    },
    {
      id: 7,
      name: "July",
    },
    {
      id: 8,
      name: "August",
    },
    {
      id: 9,
      name: "September",
    },
    {
      id: 10,
      name: "October",
    },
    {
      id: 11,
      name: "November",
    },
    {
      id: 12,
      name: "December",
    },
  ];

  const [data, setData] = useState();
  const [topSchoolReport, setTopSchoolReport] = useState();
  const [month, setMonth] = useState({
    selected_month: "",
    prev_month: "",
  });

  const getReportData = async () => {
    try {
      const res = await axiosInstance.get(
        `/getDistrictReport?report_id=${id}&auth_token=${user.auth_token}`
      );
      if (res.data.data.status === false) {
        throw new Error("Report not available");
      }
      setData(res.data.data.report_data);
      const curr_month = months.find(
        // eslint-disable-next-line eqeqeq
        (month) => month.id == res.data.data.report_data.month
      );
      const prevMonth = months.find(
        (month) => month.id === res.data.data.report_data.month - 1
      );
      setMonth(() => {
        if (curr_month.id === 1) {
          return {
            selected_month: curr_month.name,
            prev_month: "December",
          };
        } else {
          return {
            selected_month: curr_month.name,
            prev_month: prevMonth.name,
          };
        }
      });
      setTopSchoolReport(
        Object.values(res.data.data.report_data.school_wise_usage_report)
          .sort((a, b) => b.total_usage - a.total_usage)
          .slice(0, 20)
      );
    } catch (err) {
      toast.error(err.message);
      navigate(`/monthlyreport`);
    }
  };

  useEffect(() => {
    getReportData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="report-container m-5">
      {data && (
        <>
          <ReportExecutiveSummary data={data} month={month} />
          <DetailedReport data={data} />
          <ReportAppendixA data={data} month={month} />
          <div className="report-bar-chart-wrapper mt-10 mb-20">
            <ReportBarChart data={topSchoolReport} />
          </div>
          <ReportAppendixB data={data} />
          <ReportAppendixC data={data} />
        </>
      )}
    </div>
  );
};
